export const environment = {
    production: true,
    hmr: false,
    gqlUrl: 'https://gql.spekwo.com/graphql',
    website: 'https://www.spekwo.com/',
    displayWebsite: 'www.spekwo.com',
    email: 'hello@speKwo.com',
    apiHost: 'https://api.spekwo.com/',
    apiHostDisplay: 'api.spekwo.com',
    customerUrl: 'https://client.spekwo.com/',
    displayCusUrl: 'client.spekwo.com ',
    wpCouponSite: 'https://www.spekwo.com/wp-admin/edit.php?post_type=shop_coupon',
    picStories: 'https://api.spekwo.com/PictureStories/',
    ownerRoleId: '8dab2f2a-2866-4527-9b3d-d2237d8d24c7',
    executiveRoleId: "fe66b505-c5dd-46a4-94ed-acb1fabbfaab",
    juniorQuoterRoleId: "7dab2f2a-2866-4527-9b3d-d2237d8d24c7",
    seniorQuoterRoleId: "f9e6b226-7be0-44a2-a69d-b0c8a85be28f",
    onBoarderRoleId: "8dab2f2a-2866-4527-9b3d-d2237d8d24c8",
    apiHostDev: 'https://dev.api.spekwo.com/',
};



// WEBPACK FOOTER //
// /vercel/path0/src/environments/environment.ts